const colors = [
  "#ffe657",
  "#c7b1d5",
  "#adc8eB",
  "#c56183",
  "#03c4a1",
  "#fbd3d4",
  "#0779e4",
  "#f08a5d",
  "#9cdcaa",
  "#f8a19a",
  "#f0a500",
  "#32e0c4",
  "#fcc79b",
  "#81b214",
  "#68b0ab",
  "#ffe292",
  "#fe91ca",
  "#fc7e2f",
  "#00b7c2",
  "#ffd571",
  "#b2ebf2",
  "#e8505b",
  "#faafff",
  "#4e8d7c",
  "#d0e8f2",
  "#fa7f72",
  "#aee6e6",
  "#b088f9",
  "#ffa62b",
  "#1aa6b7",
  "#b8de6f",
  "#794c74",
  "#f4ebc1",
  "#d9adad",
  "#679b9b",
  "#d2e603",
  "#fcdab7",
  "#28df99",
  "#00bcd4",
  "#f6f7d4",
  "#d54062",
  "#fbd46d",
  "#96bb7c",
  "#8675a9",
  "#cdb30c",
  "#ffc7c7",
  "#8fcfd1",
  "#d3de32",
  "#35d0ba",
  "#f96d80",
  "#cceabb"
];

export default colors;
